import { ThemeProvider } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { newVyTheme } from '../assets/themes/new-vy-theme';
import { SideNavbar } from '../components/navigation/NewSideNavbar/SideNavbar';

export default function RootLayout() {
  return (
    <div className="flex h-screen">
      <div className="bg-secondary flex h-full">
        <ThemeProvider theme={newVyTheme}>
          <SideNavbar/>
        </ThemeProvider>
      </div>
      <div className="flex h-full w-full flex-col overflow-y-auto">
        <Outlet/>
      </div>
    </div>
  );
}
